import React, { useEffect } from 'react';
import { Button, Card } from 'antd';
// import { useSelector } from 'react-redux';
import { LeftOutlined } from '@ant-design/icons';
import { useDispatch, useSelector } from 'react-redux';

import Main from '../../components/layout/Main';
import BreadcrumbNav from '../../components/layout/BreadcrumbNav';
import Logout from '../../components/Logout';
import { AppDispatch, CombinedStates } from '../../core/types';
import SchoolDashboard from './SchoolDashboard';
import AdminDashboard from './AdminDashboard';

import './dashboard.scss';

const Dashboard = () => {
    const dispatch = useDispatch<AppDispatch>();
    const toolbar = [{ label: 'Item 1', link: '/abc', iconName: 'home' }];
    const navigation = [{ label: 'Item 1', link: '/abc' }, { label: 'Item 1', link: '/abc' }];
    const {
        userData,
    } = useSelector((state:CombinedStates) => state.user);

    const backLink = (
        <Button onClick={() => console.log('Back')}>
            <LeftOutlined /> BACK
        </Button>
    );

    if (userData?.role_id === 5) {
        return <SchoolDashboard />;
    }

    return (
        <Main
            className="login"
            title={<div>Administratoriaus darbalaukis</div>}
            headerTitle={<div>Administratoriaus darbalaukis</div>}
            menuWidth={350}
            menuPlacement="left"
            toolbar={toolbar}
            showFooter={false}
            floatingHeader={false}
            footerContent={<div style={{ lineHeight: '30px', fontSize: '16px', float: 'right' }}>&copy; copyright 2020</div>}
            floatingFooter
            backLink={false}
            breadcrumb={null}>
            <AdminDashboard />
        </Main>
    );
};

export default Dashboard;

Dashboard.propTypes = {};
